import React from 'react'
import { Col } from 'react-bootstrap'
import PropTypes from 'prop-types'

import { NAV_MODULE_ICON } from '../../constants'

import DeviceContentCategories from './DeviceContentCategories'
import DevicePicker from './DevicePicker'
import DeviceQueryToggle from './DeviceQueryToggle'
import messages from './messages'
import { StyledNavGenericWrapper } from './styled'
import { useAppContext } from '../../containers/App/Context'
import { getVersionIcon } from '../../helpers/utils'

/**
 * Returns a presentable Menu with Nav items defined in this module.
 * Auto wraps nav items with unset height; vertically unconstrained,
 * beholden to the current screen width.
 *
 * @module SubHeaderNavigationFlexWrapAuto
 * @alias SubHeaderNav
 *
 * @see StyledNavGenericWrapper
 *
 * @param {{
 *   currentDevice?: Device,
 *   query: Object,
 *   language: string,
 *   onSvgLoad: (string) => HTMLOrSVGImageElement,
 *   modulesAvailable: ModulesAvailable,
 *   devices: Array<Device>,
 *   toggleDeviceModal: () => void,
 *   clearDevice: () => void,
 *   productNameSingular: string,
 *   productTranslation: string,
 *   toggleSearchModal: () => void,
 *   externalNavEnabled?: boolean
 * }}
 * @return {React.ReactNode}
 */
const SubHeaderNavigationFlexWrapAuto = ({
  currentDevice,
  query,
  language,
  onSvgLoad,
  modulesAvailable,
  devices,
  toggleDeviceModal,
  clearDevice,
  productNameSingular,
  productTranslation,
  toggleSearchModal,
  externalNavEnabled,
}) => {
  const { versionKey: version } = useAppContext()
  const translated = messages[language]

  return (
    <>
      <DeviceQueryToggle
        toggleSearchModal={toggleSearchModal}
        externalNavEnabled={externalNavEnabled}
        iconSrc={getVersionIcon(NAV_MODULE_ICON.search, version)}
      />
      <Col xs={12} sm={2} className="device-nav-col">
        <DevicePicker
          devices={devices}
          toggleDeviceModal={toggleDeviceModal}
          currentDevice={currentDevice}
          clearDevice={clearDevice}
          removeIconSrc={getVersionIcon(NAV_MODULE_ICON.close, version)}
          selectIconSrc={getVersionIcon(NAV_MODULE_ICON.select, version)}
          selectTitle={
            productNameSingular
              ? translated.select.replace(
                  productTranslation,
                  productNameSingular
                )
              : translated.select
          }
        />
      </Col>
      <Col xs={12} sm={9} className="device-nav-col">
        <StyledNavGenericWrapper>
          <ul>
            <DeviceContentCategories
              currentDevice={currentDevice}
              query={query}
              language={language}
              onSvgLoad={onSvgLoad}
              modulesAvailable={modulesAvailable}
              showHomeLink
              showExpressLink={false}
              version={version}
            />
          </ul>
        </StyledNavGenericWrapper>
      </Col>
    </>
  )
}

SubHeaderNavigationFlexWrapAuto.propTypes = {
  currentDevice: PropTypes.shape({
    customerID: PropTypes.string,
    id: PropTypes.number.isRequired,
    image_location: PropTypes.string.isRequired,
    manufacturer: PropTypes.string,
    name: PropTypes.string,
    name_pretty: PropTypes.string.isRequired,
    os: PropTypes.string,
    slug: PropTypes.string.isRequired,
    vanity_name: PropTypes.string
  }),
  headerLogoLink: PropTypes.string,
  query: PropTypes.object.isRequired,
  language: PropTypes.string.isRequired,
  onSvgLoad: PropTypes.func.isRequired,
  modulesAvailable: PropTypes.shape({
    tutorials: PropTypes.bool,
    faqs: PropTypes.bool,
    guides: PropTypes.bool,
    videos: PropTypes.bool
  }).isRequired,
  externalNavEnabled: PropTypes.bool
}

export default SubHeaderNavigationFlexWrapAuto



// WEBPACK FOOTER //
// ./src/components/SubHeader/SubHeaderNavigationFlexWrapAuto.js